/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

export default function MetalSVG(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}><path d="M0 464.102V47.898l194.972 236.186V109.72L512 464.102h-79.257L255.207 269.818v194.284L64.374 225.15v238.952z" fill="currentColor" /></svg>
  );
}
